<template>
  <div>
    <!-- <HotelHero class="hotellisthero"></HotelHero> -->
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default ">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0" style="margin-top: 10%;">
            <div class="row">
              <div class="col-lg-6">
                <!-- <h1 class="display-3 text-white">Confirm Booking</h1> -->
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <HotelBookingMiddle class="mt-2 pt-5" :roomid="roomid"></HotelBookingMiddle>
  </div>
</template>
<script>
import HotelBookingMiddle from "./components/HotelBookingMiddle";
import { APIURLS } from "../api/constants";

export default {
  name: "HotelBooking",
  components: {
    HotelBookingMiddle,
  },
  data() {
    return {
      roomid: "",
    };
  },
  created() {
    if (this.$route.query.roomid) {
      this.roomid = this.$route.query.roomid;
    }
  },
};
</script>
<style scoped>
/*-------------------Room booking-----------------------*/

.bgcolorg,
.position-relative {
  background-color: #f4f5f7;
}

.position-relative {
  z-index: 1;
}

.room-booked {
  margin: 1rem;
  padding: 1rem;
  background-color: #fff;
}

.imgsize {
  width: 100%;
}

.boxed {
  width: 25%;
  height: 113px;
  border-radius: 2.8px;
  border: 1px solid #f1f1f1;
  background-color: #f1f1f1;
  text-align: center;
  position: relative;
  margin-right: 8px;
  color: #666;
  display: inline-block;
}

.cb-top {
  padding-top: 1rem;
}

.days {
  position: relative;
  display: inline-block;
  font-size: 1rem;
  font-weight: 200;
}

.blankcolor {
  background-color: #fff;
  padding: 1rem;
  margin: 1rem;
}

.gst > .col-md-2 {
  border: unset;
}
</style>